module.exports = __webpack_public_path__ + "static/media/ic_small_add.00325353.svg";